export enum ModalType {
  Error4xx = 'error4xx',
  Error5xx = 'error5xx',
  Legal = 'legal',
  Permission = 'permission',
  Success = 'success'
}

export interface ModalData {
  title: string;
  body: string;
  subText: string;
  type: ModalType;
}
